import RelatorioConta from "@/domain/conta/RelatorioConta.js";
import Table from "./Table";
export default class TableContas extends Table {
    constructor() {
        super();
    }

    getHeaders() {
        var headers;
        headers = [
            { text: "Nome", value: "rela_nome", show: true, pesq: true, enable: true },
            { text: "Data de Cadastro da Conta", value: "rela_dtRegConta", show: true, pesq: true, enable: true },
            { text: "E-mail da Conta", value: "rela_email", show: true, pesq: false, enable: true },
            { text: "Plano da Conta", value: "rela_plano", show: true, pesq: false, enable: true },
            { text: "Empresa de Faturamento", value: "rela_fat_razao", show: true, pesq: false, enable: true },
            { text: "CNPJ/CPF da Empresa de Faturamento", value: "rela_fat_cnpj", show: true, pesq: false, enable: true },
            { text: "Total de Empresas", value: "rela_totalEmp", show: true, pesq: false, enable: true },
            { text: "Total de Colaboradores", value: "rela_totalColab", show: true, pesq: false, enable: true },
            // { text: "Total de NF-e da Conta", value: "rela_totalNfe", show: true, pesq: false, enable: true },
            // { text: "Total de NFS-e da Conta", value: "rela_totalNfse", show: true, pesq: false, enable: true },
            // { text: "Total de CT-e da Conta", value: "rela_totalCte", show: true, pesq: false, enable: true },
            { text: "Empresas da conta", value: "arrayEmpresas", show: false, pesq: false, enable: false },
            { text: "_id", value: "_id", show: false, pesq: false, enable: false },
        ]
        return headers
    }

    setNota(arrayNotas, notas) {
        this.loading = false;
        for (var i = 0; i < notas.length; i++) {
            let totalColab = 0;
            for (let j = 0; j < notas[i].empresas.length; j++) {
                totalColab += notas[i].empresas[j].colaboradores.length;
            }
            arrayNotas.push(
                // password = "", file = "", dtExpiracao
                new RelatorioConta(
                    notas[i].master ? notas[i].master.nome : '',
                    notas[i].dtReg,
                    notas[i].master ? notas[i].master.email : '',
                    notas[i].plano,
                    notas[i].faturamento.razao,
                    notas[i].faturamento.cnpj,
                    notas[i].empresas.length,
                    totalColab,
                    // notas[i].total_nfe,
                    // notas[i].total_nfse,
                    // notas[i].total_cte,
                    notas[i].empresas,
                    notas[i]._id

                )
            );
            this.pagination.sortBy = 'rela_dtRegConta';
            this.pagination.descending = true;
            // arrayNotas.sort(function (a, b) {
            //     return a.emissao > b.emissao ? -1 : a.emissao < b.emissao ? 1 : 0;
            // });

        }
        return arrayNotas
    }

}





// WEBPACK FOOTER //
// ./src/domain/dataTable/TableContas.js